import { atom } from 'recoil';

export const setInventoryDetails = atom({
    key: 'setInventoryDetails', // unique ID (with respect to other atoms/selectors)
    default: [] // default value (aka initial value)
});  

 